export enum Feature {
  Graphiql = 'graphiql',
  ProtectedLink = 'protected',
  QrCode = 'qrCode',
  Subscriptions = 'subscriptions',
}
